import React, { useState, useEffect } from "react";
import { getTax } from "../../../http/api/TaxAPI";
import { Select, MenuItem, FormControl } from "@mui/material";

const TaxSelect = ({ onChange, value }) => {
  const [listTax, setListTax] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListTax() {
    let response = await getTax({});
    setListTax(response.listTaxInfo);
  }

  useEffect(() => { 
    getListTax();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listTax.map((item) => (
          <MenuItem key={item.taxId} value={item.taxId}>
            {item.taxName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default TaxSelect;
